// extracted by mini-css-extract-plugin
export var closeButton = "_7x-0";